export const checkboxConfig = [
    { name: "view", label: "View", tooltip: "View" },
    { name: "process", label: "Process", tooltip: "Process" },
    { name: "download", label: "Download", tooltip: "Download" },
    { name: "share", label: "Share with others", tooltip: "Share with others" }
];